import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FiLogOut, FiPackage } from 'react-icons/fi';
import { useSelector } from 'react-redux';
import useLogout from '../hooks/useLogout';

const SideBar = () => {
    const user = useSelector((state) => state.userController.user);
    const { pathname } = useLocation();
    const { logout } = useLogout();

    const links = [
        { path: '/', label: 'دفعات الوثائق', icon: <FiPackage /> }
    ];

    if (!user) {
        return null;
    }

    return (
        <aside className="simple-sidebar">
            <div className="logo">REFQ</div>
            <p className="user-name">{user.username}</p>
            <ul>
                {links.map((link) => (
                    <li key={link.path} className={pathname === link.path ? 'active' : ''}>
                        <Link to={link.path}>
                            <span>{link.icon}</span>
                            <p>{link.label}</p>
                        </Link>
                    </li>
                ))}
            </ul>
            <button className="logout-btn" onClick={logout}>
                <FiLogOut />
                <span>تسجيل الخروج</span>
            </button>
        </aside>
    );
};

export default SideBar;
